import { memo } from 'react';

import SecurityIconSVG from '@/assets/security-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const ISecurityIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={SecurityIconSVG} {...props} />;

export const SecurityIcon = memo(ISecurityIcon) as typeof ISecurityIcon;
